import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperatoriComponent } from './operatori.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';


@NgModule({
    declarations: [OperatoriComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    exports: [OperatoriComponent]
})
export class OperatoriModule { }
